module.exports = __webpack_public_path__ + "img/logo-large.4602f1a1.png";